import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { AreaDeleteOptionsCardBase } from '../area-delete-options-card-base';

@Component({
    selector: 'fi-area-delete-user-content-options-card',
    templateUrl: './area-delete-user-content-options-card.component.html',
    styleUrls: ['./area-delete-user-content-options-card.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AreaDeleteUserContentOptionsCardComponent extends AreaDeleteOptionsCardBase {
    getItemsToDelete(): any[] {
        return this.areaToDeleteData.UnsharedItemsToChangeOwner;
    }
}
